export enum CHAT_STATE {
  START = "start",
  OPEN = "open",
  HIDE = "hide",
  NOT_INIT = "not_init",
}
